import { apiCall } from '../../context/api';

export const fetchFormBatch = async (token, base_url, formData) => {
  if (!token) return null;

  await apiCall(base_url, token, 'POST', '/core/webhooks/batches/run-batch', formData);
};
